export default {
      id: "ic-misc-tools-usage",
      viewBox: "0 0 369 53.5",
      url: "../dist/images/" + "sprite.svg#ic-misc-tools-usage",
      toString: function () {
        return this.url;
      }
    }